import { CalendarPlus, Building2, Magnet, type LucideIcon } from "lucide-react";

import type { Permission } from "@/app/session/permissions";
import type { MessageId } from "@/shared/i18n/messages";

export interface CreateAction {
  id: string;
  labelId: MessageId;
  icon: LucideIcon;
  permission: Permission;
  /** The list page that owns the create form; `?create=1` opens it. */
  path: string;
}

/* Quick create (header, palette and the `c` shortcut) opens each page's own create form. */
export const CREATE_ACTIONS: readonly CreateAction[] = [
  { id: "lead", labelId: "create.lead", icon: Magnet, permission: "lead.create", path: "/leads" },
  {
    id: "unit",
    labelId: "create.unit",
    icon: Building2,
    permission: "inventory.create",
    path: "/units",
  },
  {
    id: "event",
    labelId: "create.event",
    icon: CalendarPlus,
    permission: "calendar-task.create",
    path: "/calendar",
  },
];

export const CREATE_PARAM = "create";

export function createHref(action: Pick<CreateAction, "path">): string {
  return `${action.path}?${CREATE_PARAM}=1`;
}
